import React from 'react';
import { Selenium, GlobalLayout } from '../'

const SeleniumPage = (props) => (
    <GlobalLayout>
        <Selenium {...props}/>
    </GlobalLayout>
);

export default SeleniumPage;